// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GdvLKIb4uhJRIs {
  height: 64px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.w8ilu8w9jY1YS0 .oFtfsYYqEI6bYn,
._098TXNRhgV_zf .oFtfsYYqEI6bYn {
  overflow-wrap: anywhere;
}
.b3aSZyaplKhQ9F {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: 40px;
  padding: 8px 8px 8px 12px;
  border-radius: 8px;
}
.b3aSZyaplKhQ9F .oFtfsYYqEI6bYn,
.b3aSZyaplKhQ9F .mVPFBv6GitYjeR {
  position: relative;
  z-index: 10;
  align-self: flex-end;
  width: 100%;
  margin-bottom: 0;
  color: #172b4d;
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 20px;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 {
  padding: 0;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .oFtfsYYqEI6bYn,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR {
  padding: 8px 8px 8px 12px;
  overflow: visible;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #ffffff 100%);
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .oFtfsYYqEI6bYn::before,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR::before {
  content: '';
  position: absolute;
  top: -32px;
  right: 0;
  left: 0;
  width: 100%;
  height: 32px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 100%);
  mix-blend-mode: normal;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR .oFtfsYYqEI6bYn {
  padding: 0px;
  background: none;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR .oFtfsYYqEI6bYn::before {
  background: none;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR .Ypxh6sBRJtShLG,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06 .mVPFBv6GitYjeR ._098TXNRhgV_zf {
  color: #172b4d;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, #000000 100%);
  color: #ffffff;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn::before,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR::before {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  mix-blend-mode: normal;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn .oFtfsYYqEI6bYn,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR .oFtfsYYqEI6bYn {
  background: none;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn .oFtfsYYqEI6bYn::before,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR .oFtfsYYqEI6bYn::before {
  background: none;
}
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn .Ypxh6sBRJtShLG,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR .Ypxh6sBRJtShLG,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .oFtfsYYqEI6bYn ._098TXNRhgV_zf,
.b3aSZyaplKhQ9F.VMg_WBNIBMLH06.XkPiuJHfzX9933 .mVPFBv6GitYjeR ._098TXNRhgV_zf {
  color: #ffffff;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Zg0_0KMgyZm4Uj {
  position: relative;
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Zg0_0KMgyZm4Uj .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Zg0_0KMgyZm4Uj .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Zg0_0KMgyZm4Uj::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.PVaQiSucflP6Rt {
  position: relative;
  background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.PVaQiSucflP6Rt .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.PVaQiSucflP6Rt .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.PVaQiSucflP6Rt::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.giqRLfbX78h6AZ {
  position: relative;
  background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.giqRLfbX78h6AZ .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.giqRLfbX78h6AZ .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.giqRLfbX78h6AZ::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.O9F6x4ZUjLLhrJ {
  position: relative;
  background-color: var(--ds-background-accent-red-subtle, #f87462);
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.O9F6x4ZUjLLhrJ .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.O9F6x4ZUjLLhrJ .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.O9F6x4ZUjLLhrJ::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.r9TdbmZ9DYX595 {
  position: relative;
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.r9TdbmZ9DYX595 .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.r9TdbmZ9DYX595 .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.r9TdbmZ9DYX595::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.klBMapupMUlJpj {
  position: relative;
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.klBMapupMUlJpj .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.klBMapupMUlJpj .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.klBMapupMUlJpj::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.DOAOOJoM4O0gvI {
  position: relative;
  background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.DOAOOJoM4O0gvI .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.DOAOOJoM4O0gvI .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.DOAOOJoM4O0gvI::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.bKgpPBXIRnfJg1 {
  position: relative;
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.bKgpPBXIRnfJg1 .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.bKgpPBXIRnfJg1 .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.bKgpPBXIRnfJg1::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Z7W_rG8Roleo3e {
  position: relative;
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Z7W_rG8Roleo3e .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Z7W_rG8Roleo3e .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-magenta-bolder, #50253f);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.Z7W_rG8Roleo3e::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.RZ0CJSGvaIQSac {
  position: relative;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.RZ0CJSGvaIQSac .oFtfsYYqEI6bYn {
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c.RZ0CJSGvaIQSac .w8ilu8w9jY1YS0 {
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F.VVHAQfn4dlq03c.RZ0CJSGvaIQSac::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  mask-repeat: repeat-y;
}
.b3aSZyaplKhQ9F.VVHAQfn4dlq03c .w8ilu8w9jY1YS0 {
  display: flex;
}
.b3aSZyaplKhQ9F.yR7xaNXvNDflBG {
  min-height: 108px;
}
.body-color-blind-mode-enabled  .VVHAQfn4dlq03c > .oFtfsYYqEI6bYn {
  left: 16px;
  width: calc(100% - 16px);
}
.body-color-blind-mode-enabled  .SwZYgjAvNRxQAV {
  display: flex;
  position: relative;
  left: 16px;
  align-items: flex-start;
  width: calc(100% - 16px);
}
.body-color-blind-mode-enabled .b3aSZyaplKhQ9F::before {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyCover": `GdvLKIb4uhJRIs`,
	"completeColorCoverChildrenName": `w8ilu8w9jY1YS0`,
	"name": `oFtfsYYqEI6bYn`,
	"completeImageCoverChildrenName": `_098TXNRhgV_zf`,
	"fullCover": `b3aSZyaplKhQ9F`,
	"doneState": `mVPFBv6GitYjeR`,
	"cardFrontImageCover": `VMg_WBNIBMLH06`,
	"imageCoverButton": `Ypxh6sBRJtShLG`,
	"darkGradient": `XkPiuJHfzX9933`,
	"cardFrontColorCover": `VVHAQfn4dlq03c`,
	"green": `Zg0_0KMgyZm4Uj`,
	"yellow": `PVaQiSucflP6Rt`,
	"orange": `giqRLfbX78h6AZ`,
	"red": `O9F6x4ZUjLLhrJ`,
	"purple": `r9TdbmZ9DYX595`,
	"blue": `klBMapupMUlJpj`,
	"sky": `DOAOOJoM4O0gvI`,
	"lime": `bKgpPBXIRnfJg1`,
	"pink": `Z7W_rG8Roleo3e`,
	"black": `RZ0CJSGvaIQSac`,
	"hasStickers": `yR7xaNXvNDflBG`,
	"completeColorCoverContainerName": `SwZYgjAvNRxQAV`
};
export default ___CSS_LOADER_EXPORT___;
